import { render, staticRenderFns } from "./_qv-stock-summary.vue?vue&type=template&id=0e651bd7&scoped=true"
import script from "./_qv-stock-summary.vue?vue&type=script&lang=js"
export * from "./_qv-stock-summary.vue?vue&type=script&lang=js"
import style0 from "./_qv-stock-summary.vue?vue&type=style&index=0&id=0e651bd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e651bd7",
  null
  
)

export default component.exports